import { putResolve } from 'redux-saga/effects';
import actions from '../../actions';
import * as DeleteVideoNoteMethods from '../../utils/api/field/DeleteVideoNoteData';

function* DeleteVideoNoteData(action) {
  const { payload, refreshPayload } = action;
  const promise = DeleteVideoNoteMethods.DeleteVideoNoteData(payload);
  const { res } = yield promise;
  yield putResolve({ type: actions.DeleteVideoNoteAction.DELETEVIDEONOTE_RECEIVED, data: res.Response });

  if (refreshPayload) {
    yield putResolve({
      type: actions.analysisAction.REQUEST_ANALYSIS_CLIPS_WITHOUT_URL,
      payload: refreshPayload
    });
  }
}

export { DeleteVideoNoteData };
